import React from "react";
import { NavLink as Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

function ClientNavbar({ path }) {
  const history = useHistory();
  function onClickLogout() {
    localStorage.removeItem("user.name");
    localStorage.removeItem("user.token");
    localStorage.removeItem("user.email");
    localStorage.removeItem("user.role");
    history.push("/");
  }
  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 mt-0 static-top shadow client-navbar">
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link className="nav-link" to="/clientdashboard" exact>
            <h6 className="mb-0">Dashboard</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/upcominginterviews" exact>
            <h6 className="mb-0">Upcoming Interviews</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/completedinterviews" exact>
            <h6 className="mb-0">Completed Interviews</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/pendinginterviews" exact>
            <h6 className="mb-0">Pending Interviews</h6>
          </Link>
        </li>
      </ul>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown no-arrow">
          <a
            className="nav-link dropdown-toggle"
            href="#/"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
          >
            <span className="mr-3 d-none d-lg-inline text-gray-600 small">
              {localStorage.getItem("user.name")}
            </span>
          </a>

          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in">
            <a className="dropdown-item" href="#/">
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Profile
            </a>
            <div className="dropdown-divider"></div>
            <button className="dropdown-item" onClick={onClickLogout}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default ClientNavbar;
